export default __webpack_public_path__ + "static/media/22.59ff287e.png";